import React from "react";
import { Body2, DotsLoader, Header3, Modal, Paper } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useVimeoPlayer } from "~/components/Hooks/useVimeoPlayer";

const VimeoPlayer = ({ videoId, open, onClose, title, description }) => {
  const { callbackRef: playerRef, isLoading } = useVimeoPlayer(videoId, { autoplay: true, responsive: true });

  return (
    <Modal
      open={open}
      onClose={onClose}
      onClickOutside={onClose}
    >
      <Paper
        style={{
          position: "absolute",
          transform: "translate(-50%, -50%)",
          top: "50%",
          left: "50%",
          width: "calc(100vw - 50px)",
          maxWidth: "960px",
          padding: "25px",
          aspectRatio: 16 / 9,
        }}
      >
        <div
          ref={playerRef}
          className={classNames({ "tw-hidden": isLoading })}
        />
        {isLoading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-p-[25px]">
            <DotsLoader />
          </div>
        ) : (
          <>
            <Header3 className="tw-mt-6">{title}</Header3>
            <Body2 className="tw-mt-4">{description}</Body2>
          </>
        )}
      </Paper>
    </Modal>
  );
};

export default VimeoPlayer;

VimeoPlayer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  videoId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};
